import {Typography, Box, Button, TableCell, TextField, TablePagination} from '@mui/material'
import {styled} from '@mui/material/styles'
import {FILTERS_DRAWER_WIDTH} from '../components/FilterPanel/FilterPanelStyle'
import {InputTitleNormal} from './common/TitleStyle'
import {InfoOutlined} from '@mui/icons-material'

const PREFIX = 'AdminPanel'

export const classes = {
  mainBox: `${PREFIX}-mainBox`
}

export const StyledButton = styled(Button)(() => ({
  marginTop: '16px',
  height: '32px',
  marginBottom: '20px'
}))

export const StyledCustomLabels = styled(Button)(() => ({
  marginTop: '-8px',
  padding: '8px',
  cursor: 'pointer',
  fontStyle: 'italic',
  background: 'none',
  letterSpacing: '0.25px',
  textDecoration: 'underline',
  '&:hover': {
    background: 'none'
  }
}))

export const StyledTypography = styled(Typography, {shouldForwardProp: (prop) => prop !== 'title'})(
  ({theme, title}) => ({
    textAlign: 'left',
    fontSize: title ? theme.typography.h5.fontSize : theme.typography.h6.fontSize,
    lineHeight: title ? theme.typography.button.lineHeight : theme.typography.h5.lineHeight,
    color: theme.palette.hpAccentBlack,
    letterSpacing: title ? '' : '0.25px'
  })
)

export const Subtitle = styled(Typography)(({theme}) => ({
  color: theme.palette.grey[700]
}))

export const StyledTitle = styled(Typography)(({theme}) => ({
  textAlign: 'left',
  fontSize: theme.typography.kpiMedium?.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.hpAccentBlack
}))
export const StyledTitleDate = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightBold
}))
export const StyledDate = styled(Typography)(({theme}) => ({
  fontFamily: theme.typography.fontFamily,
  marginLeft: theme.spacing(0.5)
}))

// Administration Box Styling
export const StyledBoxAdministration = styled(Box)(({theme}) => ({
  boxShadow: theme.shadows[2],
  width: 'auto',
  borderRadius: `${theme.spacing(0.5)} ${theme.spacing(0.5)} 0 0`,
  background: theme.palette.hpWhite,
  padding: theme.spacing(4),
  height: theme.spacing(23),
  paddingBottom: 0
}))

// Below administration box styling
export const StyledBox = styled(Box)(({theme}) => ({
  boxShadow: theme.shadows[2],
  width: 'auto',
  borderRadius: theme.spacing(0.5),
  background: theme.palette.hpWhite,
  padding: theme.spacing(4),
  overflow: 'auto',
  height: 'calc(100vh - 74px)',
  display: 'flex',
  flexDirection: 'column'
}))

export const StyledContainer = styled(Box)(({theme}) => ({
  width: 'auto',
  borderRadius: '4px',
  background: theme.palette.hpWhite,
  padding: '32px',
  overflow: 'auto',
  height: 'calc(100vh - 74px)',
  display: 'flex',
  flexDirection: 'column'
}))

export const StyledBoxContent = styled(StyledBox)(({theme}) => ({
  marginTop: theme.spacing(-1.5)
}))

export const MainBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexFlow: 'column',
  maxWidth: `calc(100vw - ${theme.spacing(8)})`,
  marginLeft: `-${FILTERS_DRAWER_WIDTH}px`,
  backgroundColor: theme.palette.hpBaseLighter,
  padding: theme.spacing(2),
  marginTop: theme.spacing(5),
  marginBottom: ''
}))

export const StyledTitleContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'space-between'
}))

export const StyledSectionTitle = styled(StyledTypography)(({theme}) => ({
  marginBottom: theme.spacing(4),
  marginLeft: theme.spacing(1),
  fontWeight: theme.typography.fontWeightSemibold
}))

export const StyledTextContent = styled(InputTitleNormal)(({theme}) => ({
  marginBottom: theme.spacing(3),
  marginLeft: theme.spacing(1),
  color: theme.palette.grey[600],
  width: '75%'
}))

export const StyledCustomButton = styled(Button)(({theme}) => ({
  marginTop: theme.spacing(1),
  marginLeft: theme.spacing(4),
  border: `1px solid ${theme.palette.primary.main}`,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    textDecoration: 'none',
    color: theme.palette.hpWhite
  }
}))

export const StyledTableCell = styled(TableCell)(({theme}) => ({
  backgroundColor: theme.palette.hpWhite
}))

export const StyledTableCellHeader = styled(Typography)(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  fontWeight: theme.typography.fontWeightSemibold
}))

export const StyledInformationBox = styled('div')(({theme}) => ({
  backgroundColor: theme.palette.hpAccentYellowLightest,
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}))

export const StyledTextField = styled(TextField)(({theme}) => ({
  '& .MuiInputLabel-root': {
    color: theme.palette.text.secondary
  },
  '& .MuiInputBase-root': {
    height: 'auto'
  }
}))

export const StyledCancelButton = styled(Button)(({theme}) => ({
  color: theme.palette.grey[700],
  padding: '20px 8px',
  height: '32px',
  '&:hover': {
    backgroundColor: theme.palette.grey[100]
  }
}))
// All new auditing admin panel style is at bottom

export const StyledAdminButtonTab = styled(Button)(({theme}) => ({
  borderRadius: theme.spacing(0.125),
  color: theme.palette.hpBaseDark,
  '&:hover': {
    border: 'none',
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
    transition: 'border-color 0.1s ease'
  },
  '&.active': {
    color: theme.palette.primary.main,
    borderBottom: `${theme.spacing(0.375)} solid ${theme.palette.primary.main}`,
    fontWeight: theme.typography?.fontWeightSemibold
  }
}))

export const StyledHeaderRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
}))

export const StyledFlexGrow = styled(Box)(() => ({
  flexGrow: 1
}))

export const StyledDataBrickContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center'
}))

export const StyledTabsStack = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: theme.spacing(7),
  minWidth: theme.spacing(50),
  maxWidth: theme.breakpoints.values.sm,
  '& > :first-child': {
    marginLeft: theme.spacing(-4),
    paddingLeft: theme.spacing(4)
  }
}))

export const ViewClientLogsButton = styled(Button)(({theme}) => ({
  paddingLeft: theme.spacing(6),
  paddingRight: theme.spacing(6),
  '&:hover': {
    color: theme.palette.primary.contrastText
  }
}))

// Paginated Log Table Styles
export const StyledLogTablePaper = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(3)
}))

export const StyledLogTableContainer = styled('div')(({theme}) => ({
  overflowX: 'auto',
  '&::-webkit-scrollbar': {
    height: theme.spacing(1)
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.grey[200],
    borderRadius: theme.spacing(0.5)
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.spacing(0.5)
  }
}))

export const StyledLogTableHeaderCell = styled(Box)(({theme}) => ({
  fontWeight: 700,
  backgroundColor: theme.palette.background.paper,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  '& .filter-icon': {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.secondary,
    opacity: 0,
    transition: 'opacity 0.2s ease',
    marginLeft: theme.spacing(0.5),
    verticalAlign: 'middle',
    cursor: 'pointer'
  },
  '&:hover .filter-icon': {
    opacity: 1
  },
  '& .filter-icon.active': {
    opacity: 1,
    color: theme.palette.primary.main
  },
  '& .filter-icon.open': {
    opacity: 1
  }
}))

export const StyledLogTablePagination = styled(Box)(({theme}) => ({
  borderBottom: 'none',
  borderTop: `1px solid ${theme.palette.divider}`,
  '& .MuiTablePagination-toolbar': {
    minHeight: theme.spacing(8),
    paddingLeft: 0
  },
  '& .MuiTablePagination-spacer': {
    flex: 'none'
  },
  '& .MuiTablePagination-selectLabel': {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.text.primary
  },
  '& .MuiTablePagination-displayedRows': {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.body1.fontSize,
    marginLeft: 'auto'
  },
  '& .MuiTablePagination-select': {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(0.5),
    padding: `${theme.spacing(0.5)} ${theme.spacing(4)} ${theme.spacing(0.5)} ${theme.spacing(1)}`,
    '&:focus': {
      borderColor: theme.palette.primary.main
    }
  }
}))

export const StyledPaginationActionsBox = styled(Box)(({theme}) => ({
  flexShrink: 0,
  marginLeft: theme.spacing(10)
}))

export const StyledUserTablePagination = styled(TablePagination)(({theme}) => ({
  borderBottom: 'none',
  width: '100%',
  '& .MuiTablePagination-toolbar': {
    minHeight: theme.spacing(8),
    paddingLeft: 0,
    width: '100%'
  },
  '& .MuiTablePagination-spacer': {
    flex: 'none'
  },
  '& .MuiTablePagination-actions': {
    marginLeft: theme.spacing(2)
  },
  '& .MuiTablePagination-selectLabel': {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.text.primary
  },
  '& .MuiTablePagination-displayedRows': {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.body1.fontSize,
    marginLeft: 'auto'
  },
  '& .MuiTablePagination-select': {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(0.5),
    padding: `${theme.spacing(0.5)} ${theme.spacing(4)} ${theme.spacing(0.5)} ${theme.spacing(1)}`,
    '&:focus': {
      borderColor: theme.palette.primary.main
    }
  }
}))

export const StyledViewPermissionLink = styled(Box)(({theme}) => ({
  color: theme.palette.hpAccentTeal,
  textDecoration: 'none',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  '&:hover': {
    textDecoration: 'underline'
  }
}))

// Styled search field for change logs
export const StyledSearchTextField = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(2),
  width: '375px'
}))

// Filter styles for change logs
export const StyledResetFiltersContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: theme.spacing(1)
}))

export const StyledResetFiltersButton = styled(Button)(({theme}) => ({
  textTransform: 'none',
  color: theme.palette.error.main,
  borderColor: theme.palette.error.main,
  '&:hover': {
    borderColor: theme.palette.error.dark,
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white
  }
}))

export const StyledFilterList = styled('ul')(({theme}) => ({
  maxHeight: 300,
  overflow: 'auto',
  minWidth: 120,
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  margin: 0,
  listStyle: 'none'
}))

export const StyledFilterListItem = styled('li')(({theme}) => ({
  cursor: 'pointer',
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  }
}))

export const StyledFilterListItemIcon = styled(Box)(() => ({
  minWidth: 28,
  display: 'flex',
  alignItems: 'center'
}))

export const StyledHeaderCellRow = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5)
}))

export const StyledHeaderCellInfoIcon = styled(InfoOutlined)(({theme}) => ({
  fontSize: theme.typography.h6.fontSize,
  color: theme.palette.text.hpBaseDark
}))
